<template>

    <div class="vx-row">

        <div class="vx-col xl:w-3/12 w-full mb-3">
            <vx-card title="Restarts" id="restartsDiv" class="vs-con-loading__container" style="height: 450px; width: 100%" >

                <template slot="actions">
                    <feather-icon icon="RefreshCwIcon" @click="loadRestartsData()"></feather-icon>
                </template>

                <p class="mb-3">
                    Channel restarts in last hour
                </p>

                <table style="width: 100%;">
                    <tr :key="index" v-for="(item, index) in restarts" style="width: 100%">
                        <td style="float: left; width: 90%; vertical-align: top; padding-bottom: .75rem;" class="font-semibold"><router-link :to="'/worker_channel/' + item.id">{{item.name}}</router-link>:</td>
                        <td style="float: right; width: 10%; vertical-align: top; padding-bottom: .75rem;">{{ item.restarts }}</td>
                    </tr>
                </table>

            </vx-card>
        </div>

        <div class="vx-col xl:w-2/12 w-full mb-3">
            <vx-card title="Offline source" id="offlineNoSourceDiv" class="vs-con-loading__container" style="height: 450px; width: 100%" >

                <template slot="actions">
                    <feather-icon icon="RefreshCwIcon" @click="loadOfflineNoSourceData()"></feather-icon>
                </template>

                <p class="mb-3">
                    Offline channels without valid source
                </p>

                <table style="width: 100%;">
                    <tr :key="index" v-for="(item, index) in offlineNoSource" style="width: 100%">
                        <td style="float: left; width: 100%; vertical-align: top; padding-bottom: 0;" class="font-semibold"><router-link :to="'/worker_channel/' + item.id">{{item.name}}</router-link></td>
                    </tr>
                </table>

            </vx-card>
        </div>

        <div class="vx-col xl:w-7/12 w-full mb-3">
            <vx-card title="Average CPU Utilization" id="avgUtilizationCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[avgUtilizationRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="avgUtilizationRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="avgUtilizationRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="avgUtilizationRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="avgUtilizationRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="avgUtilizationRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadAvgUtilizationData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="avgUtilizationChartOptions" type="line" height="350" :options="avgUtilizationChartOptions" :series="avgUtilizationData"/>

            </vx-card>
        </div>

        <div class="vx-col xl:w-1/2 w-full mb-3">
            <vx-card title="Max CPU Utilization" id="maxUtilizationCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[maxUtilizationRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="maxUtilizationRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="maxUtilizationRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="maxUtilizationRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="maxUtilizationRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="maxUtilizationRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadMaxUtilizationData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="maxUtilizationChartOptions" type="line" height="350" :options="maxUtilizationChartOptions" :series="maxUtilizationData"/>

            </vx-card>
        </div>

        <div class="vx-col xl:w-1/2 w-full mb-3">
            <vx-card title="Memory Utilization" id="memoryCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[memoryRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="memoryRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadMemoryData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="memoryChartOptions" type="line" height="350" :options="memoryChartOptions" :series="memoryData"/>

            </vx-card>
        </div>

        <div class="vx-col w-full mb-3">
            <vx-card title="Sources" id="sourcesCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[sourcesRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="sourcesRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="sourcesRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="sourcesRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="sourcesRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="sourcesRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadSourcesData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="sourcesChartOptions" type="line" height="350" :options="sourcesChartOptions" :series="sourcesData"/>

            </vx-card>
        </div>

    </div>
</template>
<script>

    import VueApexCharts from 'vue-apexcharts'

    export default {
        components: {
            VueApexCharts
        },
        data() {
            return {

                restarts: [],
                offlineNoSource: [],

                avgUtilizationData: [],
                maxUtilizationData: [],
                sourcesData: [],
                memoryData: [],

                avgUtilizationRange: 1,
                maxUtilizationRange: 1,
                sourcesRange: 1,
                memoryRange: 1,

                metricTimes: {
                    1: 'Last hour',
                    6: 'Last 6 hours',
                    12: 'Last 12 hours',
                    24: 'Last 24 hours',
                    167: 'Last 7 days'

                },

                avgUtilizationChartOptions: null,
                maxUtilizationChartOptions: null,
                sourcesChartOptions: null,
                memoryChartOptions: null

            }
        },
        methods: {
            loadData() {
                this.avgUtilizationChartOptions = this.getPercentageChartOptions('Average utilization', ['#2ecc71', '#3498db', '#f1c40f', '#e74c3c', '#e67e22', '#9b59b6', '#34495e', '#1abc9c', '#95a5a6', '#c0392b', '#7f8c8d', '#27ae60', '#2980b9', '#16a085', '#f39c12', '#d35400', '#8e44ad', '#2c3e50'], '%')
                this.maxUtilizationChartOptions = this.getPercentageChartOptions('Max utilization', ['#2ecc71', '#3498db', '#f1c40f', '#e74c3c', '#e67e22', '#9b59b6', '#34495e', '#1abc9c', '#95a5a6', '#c0392b', '#7f8c8d', '#27ae60', '#2980b9', '#16a085', '#f39c12', '#d35400', '#8e44ad', '#2c3e50'], '%')
                this.sourcesChartOptions = this.getChartOptions('Online sources', ['#7367F0', '#2ecc71', '#e74c3c', '#f1c40f'], '')
                this.memoryChartOptions = this.getPercentageChartOptions('Average memory usage', ['#2ecc71', '#3498db', '#f1c40f', '#e74c3c', '#e67e22', '#9b59b6', '#34495e', '#1abc9c', '#95a5a6', '#c0392b', '#7f8c8d', '#27ae60', '#2980b9', '#16a085', '#f39c12', '#d35400', '#8e44ad', '#2c3e50'], '%')

                this.loadAvgUtilizationData()
                this.loadMaxUtilizationData()
                this.loadSourcesData()
                this.loadMemoryData()
                this.loadRestartsData()
                this.loadOfflineNoSourceData()
            },
            loadAvgUtilizationData() {
                this.loadDataToObject('utilization/average', this.avgUtilizationRange, 'avgUtilizationData', '#avgUtilizationCard')
            },
            loadMaxUtilizationData() {
                this.loadDataToObject('utilization/max', this.maxUtilizationRange, 'maxUtilizationData', '#maxUtilizationCard')
            },
            loadSourcesData() {
                this.loadDataToObject('sources/online', this.sourcesRange, 'sourcesData', '#sourcesCard')
            },
            loadMemoryData() {
                this.loadDataToObject('memory/average', this.memoryRange, 'memoryData', '#memoryCard')
            },
            loadDataToObject(metric, time, objectName, loaderElement) {
                this.$vs.loading({
                    container: loaderElement,
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/dashboard/metrics/' + metric + '/' + time)
                loadPromise.then(function(response) {
                    thisIns[objectName] = JSON.parse(JSON.stringify(response.data))
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close(loaderElement + ' > .con-vs-loading')
                })
            },
            loadRestartsData() {
                this.$vs.loading({
                    container: '#restartsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/dashboard/metrics/restarts')
                loadPromise.then(function(response) {
                    thisIns.restarts = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#restartsDiv > .con-vs-loading')
                })
            },
            loadOfflineNoSourceData() {
                this.$vs.loading({
                    container: '#offlineNoSourceDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/dashboard/metrics/offlineNoSource')
                loadPromise.then(function(response) {
                    thisIns.offlineNoSource = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#offlineNoSourceDiv > .con-vs-loading')
                })
            },
            getPercentageChartOptions(title, colors, unit) {
                return {
                    colors: colors,
                    xaxis: {
                        type: 'datetime',
                        tickAmount: 6,
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    yaxis: {
                        min: 0,
                        max: 100,
                        tickAmount: 5,
                        decimalsInFloat: 2,
                        labels: {
                            formatter: function(value) {
                                return value.toFixed(2) + unit
                            }
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yyyy HH:mm:ss'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: title,
                        align: 'left'
                    }
                }
            },
            getChartOptions(title, colors, unit) {
                return {
                    colors: colors,
                    xaxis: {
                        type: 'datetime',
                        tickAmount: 6,
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    yaxis: {
                        min: 0,
                        tickAmount: 5,
                        decimalsInFloat: 2,
                        labels: {
                            formatter: function(value) {
                                return value.toFixed(2) + unit
                            }
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yyyy HH:mm:ss'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: title,
                        align: 'left'
                    }
                }
            }
        },
        watch: {
            avgUtilizationRange() {
                this.loadAvgUtilizationData()
            },
            maxUtilizationRange() {
                this.loadMaxUtilizationData()
            },
            sourcesRange() {
                this.loadSourcesData()
            },
            memoryRange() {
                this.loadMemoryData()
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>
